"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SearchInput =
/*#__PURE__*/
function (_Component) {
  _inherits(SearchInput, _Component);

  function SearchInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_input", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_inputWrapper", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", function (c) {
      _this._input = c;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputWrapperRef", function (c) {
      _this._inputWrapper = c;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWrapperClick", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this._input.focus();
    });

    return _this;
  }

  _createClass(SearchInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          _this$props$tabIndex = _this$props.tabIndex,
          tabIndex = _this$props$tabIndex === void 0 ? "0" : _this$props$tabIndex,
          colors = _this$props.theme.colors,
          _this$props$type = _this$props.type,
          type = _this$props$type === void 0 ? "text" : _this$props$type,
          _onChange = _this$props.onChange,
          value = _this$props.value,
          rest = _objectWithoutProperties(_this$props, ["classes", "className", "tabIndex", "theme", "type", "onChange", "value"]);

      return _react.default.createElement("div", {
        ref: this.inputWrapperRef,
        className: classes.wrapper,
        onClick: this.onWrapperClick
      }, _react.default.createElement("div", {
        className: classes.searchIcon
      }, _react.default.createElement("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 24 24"
      }, _react.default.createElement("path", {
        fill: "currentColor",
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      }))), _react.default.createElement("input", _extends({
        ref: this.inputRef,
        type: type,
        className: (0, _classnames.default)(classes.root, className),
        tabIndex: tabIndex,
        onChange: function onChange(e) {
          return _onChange(e.target.value);
        },
        value: value
      }, rest)), value && _react.default.createElement("button", {
        type: "button",
        className: classes.clearIcon,
        onClick: function onClick() {
          return _onChange("");
        }
      }, _react.default.createElement("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 24 24"
      }, _react.default.createElement("path", {
        fill: colors.error || "currentColor",
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      }))));
    }
  }]);

  return SearchInput;
}(_react.Component);

var _default = (0, _withStyles.default)(function (theme) {
  return {
    wrapper: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      minHeight: "32px",
      backgroundColor: theme.colors.white,
      border: "1px solid ".concat(theme.colors.gray300),
      padding: "0 8px",
      cursor: function cursor(props) {
        return props.disabled ? "not-allowed" : "default";
      }
    },
    root: {
      flexGrow: "1",
      width: "100%",
      color: "inherit",
      fontFamily: "inherit",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
      border: "none",
      outline: "none",
      cursor: "inherit",
      boxShadow: "none",
      // Reset default inputs for mozilla
      "-webkit-appearance": "none",
      // Reset default browser styles
      "-moz-appearance": "none" // Reset default browser styles

    },
    searchIcon: {
      flexShrink: "0",
      display: "inline-flex",
      color: theme.colors.gray300,
      marginRight: "4px"
    },
    clearIcon: {
      flexShrink: "0",
      display: "inline-flex",
      marginLeft: "8px",
      "&:focus": {
        outline: "1px dotted ".concat(theme.colors.gray400) // Modify default focus glow

      }
    }
  };
})(SearchInput);

exports.default = _default;